import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Brain, Loader2 } from "lucide-react";
import { useAuth, formatError } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Bem-vindo de volta");
      navigate("/");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#080c14] sm-grain px-4 relative overflow-hidden">
      <div className="absolute -top-40 -left-40 w-96 h-96 rounded-full bg-emerald-500/10 blur-3xl" />
      <div className="absolute -bottom-40 -right-40 w-96 h-96 rounded-full bg-indigo-500/10 blur-3xl" />
      <div className="relative w-full max-w-md sm-fade-up">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-11 h-11 rounded-xl bg-emerald-500/15 border border-emerald-500/30 flex items-center justify-center">
            <Brain className="text-emerald-400" size={22} />
          </div>
          <div>
            <h1 className="font-display font-bold text-2xl tracking-tight">Super Memória</h1>
            <p className="text-xs font-mono uppercase tracking-[0.18em] text-emerald-400/80">
              memória partilhada entre modelos
            </p>
          </div>
        </div>

        <div className="bg-slate-900/70 backdrop-blur-xl border border-slate-800 rounded-2xl p-8 shadow-2xl">
          <h2 className="font-display text-xl font-semibold mb-1">Entrar</h2>
          <p className="text-sm text-slate-400 mb-6">Acede à tua memória permanente.</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs text-slate-400 mb-1.5 block">Email</label>
              <input
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-2.5 rounded-lg bg-slate-950/60 border border-slate-800 focus:border-emerald-500/60 focus:outline-none text-sm"
                placeholder="tu@exemplo.com"
              />
            </div>
            <div>
              <label className="text-xs text-slate-400 mb-1.5 block">Password</label>
              <input
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-2.5 rounded-lg bg-slate-950/60 border border-slate-800 focus:border-emerald-500/60 focus:outline-none text-sm"
                placeholder="••••••••"
              />
            </div>
            <button
              data-testid="login-submit-button"
              disabled={busy}
              className="w-full flex items-center justify-center gap-2 py-2.5 rounded-lg bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold text-sm transition-colors disabled:opacity-60"
            >
              {busy && <Loader2 size={16} className="animate-spin" />} Entrar
            </button>
          </form>
          <p className="text-sm text-slate-400 mt-5 text-center">
            Ainda não tens conta?{" "}
            <Link to="/register" className="text-emerald-400 hover:underline">
              Criar conta
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
